module.exports = __webpack_public_path__ + "img/login_new.01120439.png";